import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useLanguageUrl } from '../utils/languageUtils';

const CTASection = () => {
  const { t } = useTranslation();
  const { getLanguageUrl } = useLanguageUrl();

  return (
    <section id="contact" className="bg-white py-16 sm:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="rounded-2xl border bg-white p-8 chip">
          <div className="text-center">
            <h2 className="text-3xl font-bold text-slate-900 sm:text-4xl">
              {t('cta.title')}
            </h2>
            <p className="mt-4 text-lg text-slate-600 max-w-2xl mx-auto">
              {t('cta.subtitle')}
            </p>
            
            <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
              <Link 
                to={getLanguageUrl('/request-placement')}
                className="rounded-2xl px-6 py-3 text-sm font-semibold text-white glow"
                style={{ background: 'linear-gradient(90deg, #06b6d4, #3b82f6, #6366f1)' }}
              >
                {t('cta.button_primary')}
              </Link>
              <button className="rounded-2xl border px-6 py-3 text-sm font-semibold bg-white chip">
                {t('cta.button_secondary')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
